var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReference105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.87 86h-5.512a.5.5 0 0 1-.44-.737A91.975 91.975 0 0 0 30.066 60H26.5A18.5 18.5 0 1 1 45 41.5a63.852 63.852 0 0 1-17.769 44.346.5.5 0 0 1-.361.154Zm-4.68-1h4.466A62.849 62.849 0 0 0 44 41.5 17.5 17.5 0 1 0 26.5 59h4.176a.5.5 0 0 1 .49.597A92.99 92.99 0 0 1 22.191 85Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF617E",
  d: "M78.87 86h-5.512a.5.5 0 0 1-.44-.737A91.933 91.933 0 0 0 82.065 60H78.5A18.5 18.5 0 1 1 97 41.5a63.854 63.854 0 0 1-17.769 44.346.499.499 0 0 1-.361.154Zm-4.679-1h4.465A62.852 62.852 0 0 0 96 41.5 17.5 17.5 0 1 0 78.5 59h4.176a.5.5 0 0 1 .49.597A92.967 92.967 0 0 1 74.19 85Z"
})));
export { SvgReference105 as ReactComponent };
export default __webpack_public_path__ + "fab00054e0cf85dc99e50f6fd505d0b8.svg";